/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleasecreateabusinessprofiletogetstarted7Inputs */

const en_pleasecreateabusinessprofiletogetstarted7 = /** @type {(inputs: Pleasecreateabusinessprofiletogetstarted7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please create a business profile to get started.`)
};

const de_pleasecreateabusinessprofiletogetstarted7 = /** @type {(inputs: Pleasecreateabusinessprofiletogetstarted7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstell zuerst ein Unternehmensprofil, um loszulegen.`)
};

/**
* | output |
* | --- |
* | "Please create a business profile to get started." |
*
* @param {Pleasecreateabusinessprofiletogetstarted7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleasecreateabusinessprofiletogetstarted7 = /** @type {((inputs?: Pleasecreateabusinessprofiletogetstarted7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleasecreateabusinessprofiletogetstarted7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleasecreateabusinessprofiletogetstarted7(inputs)
	return de_pleasecreateabusinessprofiletogetstarted7(inputs)
});
export { pleasecreateabusinessprofiletogetstarted7 as "pleaseCreateABusinessProfileToGetStarted" }